import React, { Component } from "react";
import { FontAwesomeIcon }  from '@fortawesome/react-fontawesome'
import { Button, Modal }    from "react-bootstrap";
import DropdownMenuHowAreYouFeeling      from "../../components/utils/DropdownMenuHowAreYouFeeling"
import DropdownMenuSurveyLevelOfTraining from "../../components/utils/DropdownMenuSurveyLevelOfTraining"
import LoaderButton                      from "../../components/LoaderButton";
import { WhiteLabel }                    from "../../utils/WhiteLabelProps";
import { invokeGetAthleteNotes,
         invokeSetSurveyPostWorkout } from "../../utils/AwsInvoke";
import "../../css/modal/ModalExerciseNotes.css";

var white_label     = WhiteLabel();
const MainColor     = white_label.company_primary_btn_color;
const CloseBtnColor = white_label.company_close_btn_color;

export default class ModalPostWorkoutSurvey extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showModalSimple: false,
            dropdown_val1: "Select",
            dropdown_val2: "Select"
        };

        this.handleTextChange = this.handleTextChange.bind(this);
    }

    async componentDidMount() {
        this.renderShowNotes();
    }

    async renderShowNotes() {
        var exercise_id = this.props.exercise_id;

        /*var results     = await invokeGetAthleteNotes(exercise_id);
        if(results.status) {
            this.setState({
                notes: results.notes
            })
        }*/
    }

    handleKeyPress = (target) => {
        // Allow user to hit "Enter" when using Search box //
         if(target.charCode === 13) {
             this.props.onHide();
        }
    }

    createMarkup(text) { return {__html: text}; };

    handleTextChange(event) {
        this.setState({notes: event.target.value});
    }

    handleSubmit = async event => {

        var program_id           = this.props.program_id;
        var day_id               = this.props.day_id;
        var postworkout_feeling  = this.state.dropdown_val1; //feeling_postworkout
        var level_of_training    = this.state.dropdown_val2; //level_of_training
        var comments             = this.state.notes;

        /*if(notes === "") {
              alert("Please add text to your note.")
              return;
         }*/

         const results = await invokeSetSurveyPostWorkout(program_id, day_id, postworkout_feeling, level_of_training, comments);

         if(results.status) {
              // Close Modal //
              this.props.onSurveyComplete();
         } else
              this.setState({
                  error_msg: "Ooops, looks like there was an error. Try again."
              })
    }

    handleSurvey1Question1 = (eventKey) => {
        this.setState({
            dropdown_val1: eventKey
        })
    }

    handleSurvey1Question2 = (eventKey) => {
        this.setState({
            dropdown_val2: eventKey
        })
    }
    render() {
        var notes         = this.props.notes;
        var dd_val1 = this.state.dropdown_val1;
        var dd_val2 = this.state.dropdown_val2;
        if(dd_val2 == 1) dd_val2 = "I feel undertrained and ready for more!";
        else if(dd_val2 == 2) dd_val2 = "Feel ok, but want more.";
        else if(dd_val2 == 3) dd_val2 = "Feel good and activated.";
        else if(dd_val2 == 4) dd_val2 = "Feel great; trained just beyond my limits.";
        else if(dd_val2 == 5) dd_val2 = "I feel poor - like we pushed well beyond my limits.";

        return (
            <Modal
                show={this.props.show}
                onHide={this.props.onHide}
                style={{position:"relative", top:40}}
              >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title" className="" style={{fontSize: 32}}>
                        <FontAwesomeIcon icon="clipboard-check" />&nbsp; Post-Workout Survey
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <span style={{fontSize:20}}>
                      <div className="modalFormLabelBody">
                          How are you feeling post-workout?
                          <br/>
                          <span style={{fontSize:16, color: "#888"}}>
                              1 = Not feeling good at all<br/>
                              5 = Feeling great
                          </span>
                          <br/>
                              <DropdownMenuHowAreYouFeeling title = { dd_val1 }
                                                            handle={this.handleSurvey1Question1}/>
                          <br/>
                          How was the level of training?
                          <br/>
                              <DropdownMenuSurveyLevelOfTraining title = { dd_val2 }
                                                                 handle={this.handleSurvey1Question2}/>
                          <br/>
                          { /*}<FormControl
                              onChange     = {this.handleFolderNameChange.bind(this)}
                              defaultValue = {""}
                              className    = "input-lg formModalExerciseField"
                              type         = "text"
                              onKeyPress   = {this.handleKeyPress}
                          />*/ }

                          Anything else to report?
                          <br/>
                          <span style={{fontSize:16, color: "#888"}}>
                            Excitement, determination, soreness, pain, discomfort, etc?
                          </span>
                          <textarea value={this.state.notes}
                                      onChange={this.handleTextChange}
                                      style={{height: 120, width: "100%", fontSize:20}}/>
                      </div>
                    </span>
                </Modal.Body>
                <Modal.Footer>
                      <LoaderButton
                          bsSize   = "large"
                          height   = "38px"
                          width    = "100px"
                          fontSize = "17px"
                          type     = "submit"
                          btncolor = { CloseBtnColor }
                          isLoading= {this.state.isLoading}
                          text     = "Close"
                          onClick     = {this.props.onHide}
                          loadingText = "Closing …"
                        />
                      &nbsp; &nbsp;
                      <LoaderButton
                          bsSize   = "large"
                          height   = "38px"
                          width    = "120px"
                          fontSize = "17px"
                          type     = "submit"
                          btncolor = { MainColor }
                          isLoading= {this.state.isLoading}
                          text     = "SAVE"
                          onClick     = {this.handleSubmit}
                          loadingText ="Saving survey …"
                        />
                </Modal.Footer>
              </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/modal/ModalPostWorkoutSurvey.js